import { render } from "./WebcamModal.vue?vue&type=template&id=50a610ae&scoped=true"
import script from "./WebcamModal.vue?vue&type=script&lang=js"
export * from "./WebcamModal.vue?vue&type=script&lang=js"

import "./WebcamModal.vue?vue&type=style&index=0&id=50a610ae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a610ae"]])

export default __exports__